module.exports = __webpack_public_path__ + "static/media/everybrand_logo.bf398350.svg";